var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 1.098a.725.725 0 0 0-.745.01L3.2 8.934l.016.028A.725.725 0 0 0 3 9.478v13.623c0 .26.138.5.362.629l12.39 7.172.004.002c.225.13.502.128.726-.003l12.61-7.39a.725.725 0 0 0 .357-.626V8.971a.725.725 0 0 0-.361-.625l-.005-.003m-1.798.632L16.272 2.569 5.122 9.45l10.743 6.22 11.422-6.696zM15.391 17.07l-10.94-6.335v11.949l10.941 6.334V17.07zm-.656-10.98a.58.58 0 0 1 .784-.24l3.55 1.884a.58.58 0 0 1 .286.353c.132.461.185 1.546-.674 2.328-.435.395-.966.559-1.416.616-.449.06-.867.018-1.136-.045a.58.58 0 0 1-.137-.052L11.86 8.76a.58.58 0 0 1 .54-1.027L16.46 9.87c.151.026.394.045.656.012.303-.04.581-.141.784-.325.312-.284.382-.668.37-.934l-3.295-1.749a.58.58 0 0 1-.24-.783zm10.367 10.127a.58.58 0 0 0-1.158 0v3.696l-1.958-2.197a.58.58 0 0 0-1.013.385v5.001a.58.58 0 1 0 1.16.001v-3.477l1.96 2.198a.58.58 0 0 0 1.011-.385v-5.218zm-17.47-.207a.58.58 0 0 1 .57-.014l4.348 2.319a.58.58 0 0 1-.545 1.023l-3.496-1.865v2.164l3.328 1.872a.58.58 0 1 1-.568 1.01l-2.76-1.552v1.916a.58.58 0 0 1-1.16 0v-6.377a.58.58 0 0 1 .282-.497zm9.21 13V16.778L28 10.236v12.233l-11.16 6.54z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFun);
export default __webpack_public_path__ + "static/media/FUN.958405fc359cc664471ab25e4f9b7534.svg";
export { ForwardRef as ReactComponent };